import styled from 'styled-components'

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 400px;
  max-height: 200px;
  overflow-y: auto;
`
